import React from 'react';
import { Link } from 'react-router-dom';
import img3 from '../../Assets/port3.jpg';
import img11 from '../../Assets/port11.jpg';
import img12 from '../../Assets/port12.jpg';

const featured = [
  {
    title: 'Digiori',
    tipo: 'Ecommerce',
    img: img12,
    alt: 'Digiori - tienda online ecommerce',
    descripcion: 'Ecommerce con experiencia de compra responsiva y rápida.',
    link: 'https://digiori.com.py/',
  },
  {
    title: 'Renovar PY',
    tipo: 'Ecommerce',
    img: img11,
    alt: 'Renovar PY - tienda online ecommerce',
    descripcion: 'Tienda online con catálogo, carrito y pasarela de pago.',
    link: 'https://renovarpy.com/',
  },
  {
    title: 'Tes',
    tipo: 'Landing',
    img: img3,
    alt: 'Tes - sitio corporativo institucional',
    descripcion: 'Sitio corporativo institucional.',
    link: 'https://www.tes.com.py/',
  },
];

const InicioPorafolio = () => {
  return (
    <section id='port' className="ds-section">
      <div className="ds-section-bg"></div>
      <div className="col-10 container py-5 position-relative">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-10 col-md-8">
            <span className="ds-eyebrow">Portafolio</span>
            <h2 className='text-white mt-2 mb-3 ds-titulo'>
              Nuestros últimos <span className="ds-highlight">proyectos</span>
            </h2>
            <p className="ds-lead mb-0">
              Landing pages, ecommerces y sistemas a medida desarrollados por Dscode.
            </p>
          </div>
        </div>

        <div className="row justify-content-center g-4">
          {featured.map((p) => (
            <div key={p.title} className="col-10 col-md-6 col-lg-4">
              <a
                href={p.link}
                target="_blank"
                rel="noopener noreferrer"
                className="port-card"
                aria-label={`Ver proyecto ${p.title}`}
              >
                <div className="port-card-img">
                  <img src={p.img} alt={p.alt} />
                </div>
                <span className="port-card-tag">{p.tipo}</span>
                <div className="port-card-overlay">
                  <h3 className="port-card-title">{p.title}</h3>
                  <p className="port-card-desc">{p.descripcion}</p>
                </div>
              </a>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <Link to="/portafolio" className="btn btn-neon">
            Ver todos los proyectos <i className='bx bx-right-arrow-alt ms-1'></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default InicioPorafolio;
